module.exports = __webpack_public_path__ + "img/tooltip2.eb3ef44e.svg";